import React, { useState } from "react";
import { Upload, X } from "lucide-react";
import api, { apiErr, fileUrl } from "@/lib/api";
import { toast } from "sonner";

export function ImageUpload({ value, onChange, label = "Image", testId = "image-upload", className = "" }) {
  const [busy, setBusy] = useState(false);
  const upload = async (e) => {
    const file = e.target.files?.[0]; if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData(); fd.append("file", file);
      const r = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(fileUrl(r.data.url));
    } catch (er) { toast.error(apiErr(er)); }
    setBusy(false); e.target.value = "";
  };
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid={testId}>
      {value ? (
        <div className="relative shrink-0">
          <img src={value} alt="" className="w-16 h-16 object-cover border border-sharoa-line" />
          <button type="button" data-testid={`${testId}-remove`} onClick={() => onChange("")} className="absolute -top-1.5 -right-1.5 bg-white rounded-full shadow"><X size={14} /></button>
        </div>
      ) : <div className="w-16 h-16 shrink-0 bg-sharoa-ivory border border-dashed border-sharoa-line" />}
      <label className="inline-flex items-center gap-2 border border-sharoa-line px-3 py-2 text-xs cursor-pointer hover:border-sharoa-rose">
        <Upload size={14} /> {busy ? "Uploading…" : value ? `Replace ${label}` : `Upload ${label}`}
        <input type="file" accept="image/*" hidden onChange={upload} data-testid={`${testId}-input`} />
      </label>
    </div>
  );
}

export function DeleteButton({ onDelete, label = "item", testId }) {
  const click = async (e) => {
    e.stopPropagation();
    if (!window.confirm(`Delete this ${label}? This cannot be undone.`)) return;
    try { await onDelete(); toast(`${label[0].toUpperCase() + label.slice(1)} deleted`); } catch (er) { toast.error(apiErr(er)); }
  };
  return <button type="button" data-testid={testId} onClick={click} className="text-red-500 hover:text-red-700 p-1" title={`Delete ${label}`}><X size={16} /></button>;
}

export function useSelection(items) {
  const [sel, setSel] = useState([]);
  const ids = items.map((i) => i.id);
  const allChecked = ids.length > 0 && ids.every((id) => sel.includes(id));
  const toggle = (id) => setSel((s) => (s.includes(id) ? s.filter((x) => x !== id) : [...s, id]));
  const toggleAll = () => setSel(allChecked ? [] : ids);
  return { sel, setSel, toggle, toggleAll, allChecked };
}

export function BulkBar({ count, label, onDelete, testId = "bulk-delete" }) {
  if (!count) return null;
  const click = async () => {
    if (!window.confirm(`Delete ${count} selected ${label}${count > 1 ? "s" : ""}? This cannot be undone.`)) return;
    try { await onDelete(); toast(`${count} ${label}${count > 1 ? "s" : ""} deleted`); } catch (er) { toast.error(apiErr(er)); }
  };
  return (
    <div data-testid={`${testId}-bar`} className="flex items-center justify-between bg-sharoa-charcoal text-white px-4 py-2.5 mb-3 text-sm">
      <span data-testid={`${testId}-count`}>{count} selected</span>
      <button data-testid={`${testId}-btn`} onClick={click} className="bg-red-600 hover:bg-red-700 text-white text-xs uppercase tracking-widest px-4 py-2">Delete Selected</button>
    </div>
  );
}
